import React from 'react';
import { IconProps } from '.';

const SvgCircleQuestionFill = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1Zm-.75 14.6v1.7h1.5v-1.7h-1.5ZM12 6.25c-1.867 0-3.25 1.61-3.25 3.375h1.5c0-1.035.807-1.875 1.75-1.875.866 0 1.696.761 1.747 1.65v.18c-.022.355-.162.663-.403.99-.258.348-.56.633-.933 1.032l-.003.002-.004.004-.011.013-.04.041a5.215 5.215 0 0 0-.505.637c-.26.387-.598 1.007-.598 1.701h1.5c0-.24.133-.552.343-.865a3.692 3.692 0 0 1 .374-.468l.002-.002.01-.01.01-.011c.295-.318.73-.738 1.06-1.182.35-.473.65-1.055.695-1.791l.006-.176C15.258 7.69 13.67 6.25 12 6.25Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgCircleQuestionFill;
